import { render } from "./club-special-event-add.vue?vue&type=template&id=072f1ab7"
import script from "./club-special-event-add.vue?vue&type=script&lang=js"
export * from "./club-special-event-add.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__